import { render, staticRenderFns } from "./CardFavIcon.vue?vue&type=template&id=20bda022"
import script from "./CardFavIcon.vue?vue&type=script&lang=js"
export * from "./CardFavIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports